import { IError, ReadFileResponse } from '..';

export function isError(a: ReadFileResponse | IError): a is IError {
  return (
    (a as IError).code !== undefined && (a as IError).message !== undefined
  );
}
